import AxiosBase from "@/assets/js/axios-base";
import Axios from "@/assets/js/axios";

let axiosBase = new AxiosBase();
let $axios = Axios.http;

const state = {
  deviceList: []
};

const getters = {
  deviceList: state => state.deviceList
};

const actions = {
  async postSaveDevice({ commit, state }, payload) {
    return $axios.post(axiosBase.getUrls().postDeviceRegistration, payload);
  },

  async fetchDeviceList({ commit }) {
    const response = await $axios.get(axiosBase.getUrls().getDeviceList);
    console.log(response.data.data);
    commit("setDeviceList", response.data.data);
    return response;
  },

  async deleteDevice({ commit }, deviceId) {
    const response = await $axios.delete(axiosBase.getUrls().deleteDevice + deviceId);
    return response;
  }
};

const mutations = {
  setDeviceList(state, deviceList) {
    state.deviceList = deviceList;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
